import AgentHeader from '@/components/App/Header/AgentHeader';
import { useAppContext } from '@/contexts/AppContext';
import { useGetUseRole } from '@/hooks/useGetUserRole';
import AgentBookmarkHotels from '@/pages/AgentDashboard/AgentBookmarkHotels';
import AgentProfile from '@/pages/AgentDashboard/AgentProfile';
import AgentUsers from '@/pages/AgentDashboard/AgentUsers';
import AgentBookingsPage from '@/pages/AgentDashboard/Bookings/AgentBookings.page';
import AgentDashboard from '@/pages/AgentDashboard/Dashboard';
import AgentFABookingsPage from '@/pages/AgentDashboard/FaBookings/AgentFaBookings.page';
import AgentOnHoldBookingsPage from '@/pages/AgentDashboard/OnHoldBookings/AgentOnHoldBookings.page';
import AgentOrderBookingsPage from '@/pages/AgentDashboard/OrderBookings/AgentOrderBookings.page';
import OrderDetailPage from '@/pages/AgentDashboard/OrderDetail/OrderDetail.page';
import AgentTodoList from '@/pages/AgentDashboard/TodoList/TodoList';
import { AppUrls } from '@/urls';

import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Link, Redirect, useLocation } from 'react-router-dom';

export default function AgentLayout() {
  const { pathname } = useLocation();
  const { auth } = useAppContext();
  const isActiveLink = React.useCallback(
    (link: string) => {
      return pathname.startsWith(link);
    },
    [pathname],
  );

  const roles = useGetUseRole();
  const menus = React.useMemo(() => {
    let sidebarContent = [
      {
        icon: 'icon-home',
        name: 'Dashboard',
        routePath: AppUrls.AgentDashboard,
      },

      {
        icon: 'icon-airplane',
        name: 'Booking Report',
        routePath: AppUrls.AgentBookings,
      },
    ];

    if (roles.isAdmin || roles.isBooking) {
      sidebarContent = [
        {
          icon: 'icon-home',
          name: 'Dashboard',
          routePath: AppUrls.AgentDashboard,
        },
        {
          icon: 'icon-menu',
          name: 'Processing Booking',
          routePath: AppUrls.AgentTodoList,
        },
        {
          icon: 'icon-bell-ring',
          name: 'On-hold Booking',
          routePath: AppUrls.AgentOnHoldBookings,
        },
        {
          icon: 'icon-compass',
          name: 'Booking Order',
          routePath: AppUrls.AgentOrderBookings,
        },
        {
          icon: 'icon-airplane',
          name: 'Booking Report',
          routePath: AppUrls.AgentBookings,
        },
        {
          icon: 'icon-arrow-right',
          name: 'For Agent Booking',
          routePath: AppUrls.AgentFaBookings,
        },
      ];
    }

    if (roles.isAdmin) {
      sidebarContent.push({
        icon: 'icon-traveller',
        name: 'Agent Profile',
        routePath: AppUrls.AgentProfile,
      });
      sidebarContent.push({
        icon: 'icon-user',
        name: 'User Management',
        routePath: AppUrls.AgentUsers,
      });
    }

    if (!auth?.hasFaBookings) {
      sidebarContent = sidebarContent.filter(item => item.routePath !== AppUrls.AgentFaBookings);
    }
    return sidebarContent;
  }, [roles, auth]);
  return (
    <>
      <div className="header-margin"></div>
      <Helmet>
        <title>Agent dashboard</title>
      </Helmet>
      <AgentHeader />
      <div className="dashboard agent-dashboard">
        <div className="dashboard__sidebar bg-white scroll-bar-1">
          <div className="sidebar -dashboard">
            {menus.map(item => (
              <div className="sidebar__item" key={item.routePath}>
                <div className={`${isActiveLink(item.routePath) ? '-is-active' : ''} sidebar__button `}>
                  <Link to={item.routePath} className="d-flex items-center text-15 lh-1 fw-500">
                    <i className={`${item.icon} text-20 px-15 text-blue-1`}></i>
                    {item.name}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="dashboard__main">
          <div className="dashboard__content bg-light-2">
            <div className="omega-content pb-20">
              <Switch>
                <Route exact path={AppUrls.AgentDashboard} component={AgentDashboard} />
                <Route exact path={AppUrls.AgentProfile} component={AgentProfile} />
                <Route exact path={AppUrls.AgentUsers} component={AgentUsers} />
                <Route exact path={AppUrls.AgentBookmarks} component={AgentBookmarkHotels} />
                <Route exact path={AppUrls.AgentBookings} component={AgentBookingsPage} />
                <Route exact path={AppUrls.AgentFaBookings} component={AgentFABookingsPage} />
                <Route exact path={AppUrls.AgentOnHoldBookings} component={AgentOnHoldBookingsPage} />
                <Route exact path={AppUrls.AgentOrderBookings} component={AgentOrderBookingsPage} />
                <Route exact path={AppUrls.AgentOrderDetail} component={OrderDetailPage} />
                <Route exact path={AppUrls.AgentTodoList} component={AgentTodoList} />

                <Redirect from="*" to={AppUrls.AgentDashboard} />
              </Switch>
            </div>

            <footer className="footer -dashboard">
              <div className="footer__row row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row y-gap-20 items-center">
                    <div className="col-auto">
                      <div className="text-14 lh-14 mr-30">© {new Date().getFullYear()} NTA All rights reserved.</div>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
}
